import Barriers from "./Barriers";

function Addresses({addresses, barriers, cameras}) {
    return (
      <>
      <h2>Адреса</h2>
      <div className="data-list">
        {addresses.map(addr => (
          <div key={addr.id} className="data-item">
            <h3>{addr.name}</h3>
            <br></br>
            <Barriers addressId={addr.id} barriers={barriers} cameras={cameras}></Barriers>
          </div>
        ))}
      </div>
      </>
    );
};

export default Addresses;